<template>
  <button
    :class="buttonClasses"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'CheckPanelButton',
  props: {
    correct: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonClasses () {
      return {
        'button': true,
        'yes': this.correct,
        'no': !this.correct
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  float: left;
  width: 50%;
  font-weight: $fw-semi;
  font-size: $fs-normal;
  line-height: $lh-heading;
  padding: 10px;
  background: none;
  border: none;
  text-transform: lowercase;
}

.yes {
  color: $c-blue;
}

.no {
  color: $c-red;
}
</style>
